import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const ErrorCircleIcon: React.FC<IconProps> = ({
  color = theme.palette.error.main,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  fillOpacity,
  isFilled = false,
}) => {
  const icon = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12c0 2.6522 1.05357 5.1957 2.92893 7.0711C6.8043 20.9464 9.34784 22 12 22c2.6522 0 5.1957-1.0536 7.0711-2.9289C20.9464 17.1957 22 14.6522 22 12c0-2.65216-1.0536-5.1957-2.9289-7.07107C17.1957 3.05357 14.6522 2 12 2 9.34784 2 6.8043 3.05357 4.92893 4.92893 3.05357 6.8043 2 9.34784 2 12Zm14.0276-4.03036c.2929.29288.2929.76775 0 1.06066L13.0582 12l2.9699 2.9696c.293.2929.293.7678.0001 1.0607-.2929.2929-.7677.2929-1.0607.0001l-2.9699-2.9696-2.96919 2.9695c-.29288.2929-.76775.2929-1.06066.0001-.29291-.2929-.29294-.7678-.00006-1.0607l2.96921-2.9695-2.97013-2.96984c-.29291-.29288-.29294-.76775-.00006-1.06066.29288-.29291.76775-.29294 1.06066-.00006l2.97013 2.96976 2.9694-2.9697c.2929-.29291.7678-.29294 1.0607-.00006Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12c0 2.6522 1.05357 5.1957 2.92893 7.0711C6.8043 20.9464 9.34784 22 12 22c2.6522 0 5.1957-1.0536 7.0711-2.9289C20.9464 17.1957 22 14.6522 22 12c0-2.65216-1.0536-5.1957-2.9289-7.07107C17.1957 3.05357 14.6522 2 12 2 9.34784 2 6.8043 3.05357 4.92893 4.92893 3.05357 6.8043 2 9.34784 2 12Zm1.5 0c0 2.2543.89553 4.4163 2.48959 6.0104C7.58365 19.6045 9.74566 20.5 12 20.5c2.2543 0 4.4163-.8955 6.0104-2.4896C19.6045 16.4163 20.5 14.2543 20.5 12c0-2.25434-.8955-4.41635-2.4896-6.01041C16.4163 4.39553 14.2543 3.5 12 3.5c-2.25434 0-4.41635.89553-6.01041 2.48959C4.39553 7.58365 3.5 9.74566 3.5 12Zm12.5276-4.03036c.2929.29288.2929.76775 0 1.06066L13.0582 12l2.9699 2.9696c.293.2929.293.7678.0001 1.0607-.2929.2929-.7677.2929-1.0607.0001l-2.9699-2.9696-2.96919 2.9695c-.29288.2929-.76775.2929-1.06066.0001-.29291-.2929-.29294-.7678-.00006-1.0607l2.96921-2.9695-2.97013-2.96984c-.29291-.29288-.29294-.76775-.00006-1.06066.29288-.29291.76775-.29294 1.06066-.00006l2.97013 2.96976 2.9694-2.9697c.2929-.29291.7678-.29294 1.0607-.00006Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper aria-label="ErrorCircleIcon" size={size} viewBox={viewBox} fill="none">
      {icon}
    </SvgWrapper>
  )
}

export default ErrorCircleIcon
